<template>
  <component :is="layoutComponent" :model="model" :editing="editing" :site="site" :device="device" />
</template>

<script>
import RowContent from './rowContent.vue'
import ColContent from './colContent.vue'

export default {
  name: 'SignActivityWidget',
  components: { RowContent, ColContent },
  props: {
    model: { type: Object, default() { return {} } },
    editing: { type: Boolean, default: false },
    device: { type: String, default: 'desktop' },
    site: Object
  },
  computed: {
    layoutComponent() {
      return (this.model?.layout === 'col') ? 'ColContent' : 'RowContent'
    }
  }
}
</script>
